import { routeConstants } from "constants/routeConstants";
import { useSubscription } from "pages/Settings/Subscriptions/useSubscription";
import { FC } from "react";
import { BsArrowRight } from "react-icons/bs";
import { CiCircleCheck } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import {
    ChooseButton,
    DollarSign,
    Feature,
    FeatureIcon,
    FeaturesSection,
    FeatureText,
    OptionName,
    OptionNameSection,
    Per,
    Price,
    PriceSection,
    PricingOptionWrapper,
    ProPricingCard
} from "./PricingOption.styled";
import { PricingOptionProps } from "./types";

export const PricingOption: FC<PricingOptionProps> = ({
    name,
    perMonthPrice,
    perYearPrice,
    isLoading,
    isCurrent,
    features,
    intervalToShow,
    handleChoosePlan,
}) => {
      
    const {
        currentPlan,
    } = useSubscription();
    const navigateTo = useNavigate();

    const handleButtonClick = () => {
        if (currentPlan === name) {
            navigateTo(routeConstants.subscriptionSettings);
        } else {
            handleChoosePlan();
        }
    };

      return (
        <PricingOptionWrapper>
            {name === 'Pro' ? <ProPricingCard>Popular</ProPricingCard> : ''}
            <OptionNameSection>
                {/* <OptionIcon src={ProBadge} alt="icon" /> */}
                <OptionName variant="body1">{name}</OptionName>
            </OptionNameSection>
            <PriceSection>
                <DollarSign>AED</DollarSign>
                <Price variant="heading1">{intervalToShow === 'month' ? perMonthPrice : perYearPrice}</Price>
                <Per variant="body3">{intervalToShow === 'month' ? '/mo' : '/yr'}</Per>
                </PriceSection>
            <FeaturesSection>
                {features.map((feature) => (
                    <Feature>
                      <FeatureIcon><CiCircleCheck/></FeatureIcon> 
                        <FeatureText variant="body3">{feature}</FeatureText>
                    </Feature>
                ))}
            </FeaturesSection>
            <ChooseButton
                variant="filled"
                type="button"
                disabled={isCurrent}
                isLoading={isLoading}
                onClick={handleButtonClick}
            >
                {currentPlan === name ? "View Plan" : "Choose Plan"}<BsArrowRight fontSize={16} style={{right: '-0.5rem',position: 'relative', top: '0.18rem'}}/>
            </ChooseButton>
        </PricingOptionWrapper>
    );
};
